var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWestfieldPlusinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M43.05 13s.614 3.713 1.374 8.403c.155 2.593-1.678 4.53-1.678 4.53l-4.89 4.885-6.33 6.307c.02.175.045.35.07.508.993 6.915-8.854 13.356-8.854 13.356l-.947-1.136c3.454-2.934 2.84-6.25 2.84-6.25-.889-5.32-1.6-9.464-2.172-12.697l-6.292 6.262q.042.293.082.563c.992 6.913-8.857 13.356-8.857 13.356l-.945-1.14c3.454-2.936 2.838-6.249 2.838-6.249C5.219 19.33 4.885 19.57 4.395 19.023c-1.045-1.157-4.168.044-4.168.044L0 18.156l12.338-5.03s2.143 13.005 3.38 21.062l5.454-5.507s.697-.68.506-1.917c-.781-4.222-1.215-6.136-1.5-7.069-.148-.424-.255-.566-.36-.683l-.079-.086c-1.043-1.158-4.167.047-4.167.047l-.225-.911 12.337-5.031s2.152 13.07 3.392 21.126l-.123-.868-.004-.026.004.016.113.722.022.144 5.517-5.574q.002-.001.046-.056c.19-.254.544-.863.392-1.785-.777-4.218-1.209-6.135-1.497-7.067-.183-.53-.307-.625-.437-.774-1.044-1.15-4.166.048-4.166.048l-.23-.908.059-.024Zm13.345 16.065.01 7.677h7.416l.008 4.973h-7.416l.01 7.764h-5.626l-.011-7.764h-7.502l-.008-4.973h7.503v-7.677z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "#161719"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#161719",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
})))));
export default SvgWestfieldPlusinline;